/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InvestmentIntermediaryDetails } from './InvestmentIntermediaryDetails';
import {
    InvestmentIntermediaryDetailsFromJSON,
    InvestmentIntermediaryDetailsFromJSONTyped,
    InvestmentIntermediaryDetailsToJSON,
} from './InvestmentIntermediaryDetails';

/**
 * 
 * @export
 * @interface IntermediaryDetailsViewModel
 */
export interface IntermediaryDetailsViewModel {
    /**
     * 
     * @type {string}
     * @memberof IntermediaryDetailsViewModel
     */
    clientId: string;
    /**
     * 
     * @type {Array<InvestmentIntermediaryDetails>}
     * @memberof IntermediaryDetailsViewModel
     */
    investments: Array<InvestmentIntermediaryDetails>;
}

/**
 * Check if a given object implements the IntermediaryDetailsViewModel interface.
 */
export function instanceOfIntermediaryDetailsViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "clientId" in value;
    isInstance = isInstance && "investments" in value;

    return isInstance;
}

export function IntermediaryDetailsViewModelFromJSON(json: any): IntermediaryDetailsViewModel {
    return IntermediaryDetailsViewModelFromJSONTyped(json, false);
}

export function IntermediaryDetailsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntermediaryDetailsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'clientId': json['ClientId'],
        'investments': ((json['Investments'] as Array<any>).map(InvestmentIntermediaryDetailsFromJSON)),
    };
}

export function IntermediaryDetailsViewModelToJSON(value?: IntermediaryDetailsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ClientId': value.clientId,
        'Investments': ((value.investments as Array<any>).map(InvestmentIntermediaryDetailsToJSON)),
    };
}

